import React from 'react'
import {
	IonText,
	IonButton,
	IonImg,
} from '@ionic/react'
import { Icon } from '@iconify/react'
import newProtocolActivated from '../../assets/images/new-protocol-activated.png'

const ProtocolCongratulations = ({ protocol, onFinish }) => {
	if (!protocol) {
		return null
	}

	return (
		<div>
			<div className="congratulations-content">
				<div className="congratulations-container">
					<h1>Complimenti!</h1>
					<h2>Hai attivato il tuo Protocollo {protocol.name}</h2>

					<div className="protocol-badge">
						<IonImg 
							src={newProtocolActivated} 
							alt="Protocol Badge"
							className="protocol-badge-image"
						/>
					</div>
					
					<p className="congratulations-message">
						Hai fatto il primo passo verso i tuoi obiettivi. Il percorso ora è solo tuo: chiaro, guidato e accompagnato.
					</p>

					<div className="what-awaits">
						<h3>Cosa ti aspetta</h3>
						<div className="features-list">
							<div className="feature-item">
								<Icon className="feature-icon" icon="solar:calendar-linear" />
								<span>Un percorso nutrizionale di {protocol.duration} giorni</span>
							</div>
							<div className="feature-item">
								<Icon className="feature-icon" icon="solar:chat-round-line-linear" />
								<span>Chat e community motivazionale</span>
							</div>
							<div className="feature-item">
								<Icon className="feature-icon" icon="solar:user-plus-outline" />
								<span>Contatto diretto con i nutrizionisti del team</span>
							</div>
						</div>
					</div>


				</div>
			</div>
			<div className="buttons">
				<IonButton
					shape="round"
					onClick={onFinish}
					color="primary"
					expand="full"
				>
					Avanti
				</IonButton>
			</div>
		</div>
	)
}

export default ProtocolCongratulations
